import React from 'react';
// components
import PassengerItemForPrint from 'components/PassengerItem/PassengerItemForPrint';

const PassengersListForPrint = ({
  passengersList,
  page,
  passengersPages,
  pageLimit,
  calendarBtnText,
  totalTickets,
  totalPassengers,
}) => {
  return (
    <>
      <div className="print-passengers__header">
        <h1 className="print-passengers__title">Інформація про пасажирів</h1>
        <p className='print-passengers__calendar'>
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none" >
            <path d="M1 7.66667H21M5.44444 1V3.22222M16.5556 1V3.22222M4.33333 11H6.55556M9.88889 11H12.1111M15.4444 11H17.6667M4.33333 14.3333H6.55556M9.88889 14.3333H12.1111M15.4444 14.3333H17.6667M4.33333 17.6667H6.55556M9.88889 17.6667H12.1111M15.4444 17.6667H17.6667M4.55556 21H17.4444C18.689 21 19.3113 21 19.7867 20.7578C20.2048 20.5448 20.5448 20.2048 20.7578 19.7867C21 19.3113 21 18.689 21 17.4444V6.77778C21 5.53321 21 4.91093 20.7578 4.43558C20.5448 4.01743 20.2048 3.67748 19.7867 3.46443C19.3113 3.22222 18.689 3.22222 17.4444 3.22222H4.55556C3.311 3.22222 2.68871 3.22222 2.21336 3.46443C1.79521 3.67748 1.45526 4.01743 1.24221 4.43558C1 4.91093 1 5.53321 1 6.77778V17.4444C1 18.689 1 19.3113 1.24221 19.7867C1.45526 20.2048 1.79521 20.5448 2.21336 20.7578C2.68871 21 3.31099 21 4.55556 21Z" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
          {calendarBtnText}
        </p>
        <p className='print-passengers__count'>
          {`${page} / ${passengersPages}`}
        </p>
      </div>
      <div className="print-passengers__body">
        <div className="print-passengers__total-box">
          <p> Кількість пасажирів: <span>{totalPassengers}</span> </p>
          <p> Кількість квитків: <span>{totalTickets}</span> </p>
        </div>
        <div className="print-passengers__titles">
          <span className="print-passenger__number"></span>
          <span className="print-passenger__full-name">ПІБ Пасажира</span>
          <span className="print-passenger__phone">Номер телефону</span>
          <span className="print-passenger__ticket-price">Ціна квитка</span>
          <span className="print-passenger__number-of-tickets">К-сть квитків</span>
          <span className="print-passenger__seats">Місце</span>
          <span className="print-passenger__direction">Напрям</span>
          <span className="print-passenger__comment">Коментар</span>
        </div>
        <ul className="print-passengers__list">
          {passengersList &&
            passengersList?.map((i, idx) => {
              const passengerNumber = (page - 1) * pageLimit + (idx + 1);

              return (
                <PassengerItemForPrint
                  key={i?.passenger_id || idx}
                  data={i}
                  passengerNumber={passengerNumber}
                />
              );
            })}
        </ul>
      </div>
    </>
  );
};

export default PassengersListForPrint;
